export { default as SuccessUpdatePreferences } from './SuccessUpdatePreferences';
